import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';

import { AppRoutes } from 'router/models';

import { getAffiliateOffer } from '../services';

export const useGetAffiliateOffer = (publicCode: string | undefined) => {
  const navigate = useNavigate();

  return useQuery(
    ['affiliateOffer', publicCode],
    () => {
      if (publicCode) {
        return getAffiliateOffer(publicCode);
      }

      return null;
    },
    {
      onError: () => {
        navigate(AppRoutes.Base);
      },
      enabled: !!publicCode,
      retry: false,
      refetchOnWindowFocus: false,
    }
  );
};
